import classNames from 'classnames';

export const getWrapperClassNames = (className: string, isOpen: boolean, disabled = false) =>
  classNames({
    dropdown__value: true,
    'dropdown__value--disabled': disabled,
    'dropdown__value--visible': isOpen,
    [`${className}__value`]: className,
    [`${className}__value--visible`]: className && isOpen,
  });

export const getLabelClassNames = (className: string, isOpen: boolean) =>
  classNames({
    dropdown__label: true,
    'dropdown__label--visible': isOpen,
    [`${className}__label`]: className,
    [`${className}__label--visible`]: className && isOpen,
  });

export const getIconClassNames = (className: string, isOpen: boolean) =>
  classNames({
    dropdown__icon: true,
    'dropdown__icon--visible': isOpen,
    [`${className}__icon`]: className,
    [`${className}__icon--visible`]: className && isOpen,
  });

export const getDropdownClassName = (overlayClassName: string, disabled = false) =>
  classNames({
    [`${overlayClassName}`]: overlayClassName,
    light: true,
    dropdown: true,
    'dropdown--disabled': disabled,
  });
